import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionService } from '@shared/services/session.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnleashProviderGuard implements CanActivate {
  private session: SessionService = inject(SessionService);
  constructor() {}

  async canActivate(): Promise<boolean> {
    try {
      const currentSession = await firstValueFrom(this.session.current$);
      if (currentSession?.provider === 'unleash') {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
}
